/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Messages_Mode_GroupInputs */

const en_messages_mode_group = /** @type {(inputs: Messages_Mode_GroupInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Group`)
};

const he_messages_mode_group = /** @type {(inputs: Messages_Mode_GroupInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`קבוצה`)
};

/**
* | output |
* | --- |
* | "Group" |
*
* @param {Messages_Mode_GroupInputs} inputs
* @param {{ locale?: "en" | "he" }} options
* @returns {LocalizedString}
*/
export const messages_mode_group = /** @type {((inputs?: Messages_Mode_GroupInputs, options?: { locale?: "en" | "he" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Messages_Mode_GroupInputs, { locale?: "en" | "he" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_messages_mode_group(inputs)
	return he_messages_mode_group(inputs)
});